export const formatMyBookingDate = (value: string | undefined) => {
  if (!!value) {
    const result = value?.split("-").reverse();
    result[2] = result[2].replace("20", "");
    return result.join(".");
  }
  return null;
};
